import axios from "axios";
import * as utils from "./utils";
import NEXUS_CONST from "./constants";
const API_ENDPOINT = NEXUS_CONST.API_ENDPOINT + "api/";

const getRequestOptions = (props) => {
  let config = {
    url: props[0],
    method: props[1],
    baseURL: API_ENDPOINT,
    timeout: 20000,
    responseType: "json",
    headers: {
      hid: utils.get("hid"),
      email: utils.get("mailid"),
      username: utils.get("username"),
      "customer-id": utils.get("tenantId"),
      Accept: "application/json",
      Authorization: `Bearer ${utils.get("accessToken")}`,
    },
  };

  if (props[2]) {
    config["data"] = props[2];
  }

  if (props[3]) {
    config["responseType"] = props[3];
  }
  if (props[4]) {
    config["responseEncoding"] = props[4];
  }

  return config;
};

export default (...props) => {
  let options = getRequestOptions(props);
  return axios(options);
};
